import { AnyBoltHole } from '../__generated/model/index.js';
import { getHolePositions } from '../util/hole-positions.js';
import { createCirclePolygon } from './shapes.js';
export const createMultipleHolePolygons = (hole, plate, count)=>{
    const plateSize = {
        x: plate.$sizeX,
        y: plate.$sizeY
    };
    const holePositions = getHolePositions(hole, plateSize, count);
    const radius = AnyBoltHole.is(hole) ? hole.radius : hole.bottomRadius;
    return holePositions.map(({ x, y })=>createCirclePolygon({
            center: {
                x,
                y
            },
            radius
        }));
};

//# sourceMappingURL=multple-fixing-holes.js.map